 function addRemoveProgress_s(s,w){          
                  $(".cust-shptxt").html(s);
                   $(".cust-prg b").attr("style",w);
  }
  function addRemoveProgress(s,w){          
                  $(".cust-shptxt").html(s);
                   $(".cust-prg b").attr("style",w);
  }
function coupon_add(){
  $(".discount-code__submit").click(function(){
  console.log($("#discount-code-input").val())
  console.log($(".cart__subtotal").html().replace(/[^0-9\.]/g, ''))
  if(parseFloat($(".cart__subtotal").html().replace(/[^0-9\.]/g, '')) > 1690){
  window.location.href = "/discount/"+ $("#discount-code-input").val() +"?redirect=/checkout";
  }
})
}
function upsells_slick(){
/*if(document.querySelector(".upsells_container").classList.contains("slick-slider")){
 $('.upsells_container').slick('unslick');
}*/
  if (window.matchMedia("(min-width: 750px)").matches) {
  $('.upsells_container').slick({
   dots: false, 
   arrows: true,
    infinite: true,
    autoplay:false,
    variableWidth: true,
        draggable: true,
       swipe:true,
        prevArrow:$(".splide__arrow--prev"),
        nextArrow:$(".splide__arrow--next"),
    
  });
  }

    $(".product-card-sample__add-to-cart").click(function(e){
    e.preventDefault();
    console.log($( this ).closest(".product-form-slide").find("input,select,textarea").serialize())
    let url_c = "/cart"
if (window.location.href.indexOf("/en") > -1) {
   url_c = "/en/cart"
}
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $( this ).closest(".product-form-slide").find("input,select,textarea").serialize(),
      dataType: 'json',
      success: function(response){
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cartdata){
            $('#cart-count').html(cartdata.item_count);
            if(cartdata.item_count > 0){
              $('#cart-count').removeClass('visually-hidden');
            }
            if(cartdata.item_count == 0){
              $('#cart-count').addClass('visually-hidden');
            }
            $.ajax({
              type: "GET",
              url: url_c,
              dataType: 'html',
              success: function(data){
               var minicartdata = $(data).filter('#slidingcartmain').html();
                  var progree_msg = $(data).find(".cust-shptxt").html();
                var progree_width = $(data).find(".cust-prg b").attr("style");
                addRemoveProgress_s(progree_msg,progree_width);
               setTimeout(function(){
                   upsells_slick();
                },200)
                  $('#slidingcartmain').html(minicartdata);     
              }
            });

          }

        });

      },
      error: function(resp) {
        var getres = JSON.stringify(resp);
        alert(resp.responseJSON.description);
      }
    });

  });

  
}
upsells_slick()




$(document).ready(function(){
 
  $(".cart a").click(function(e){
    e.preventDefault();

    /*BS team: added this code becuase mini-cart should not open cart page */
    if ($(location).attr("href").includes('/cart'))
      return;
    /***********/

    $("#overlay").addClass("is-active");
    $(".inline-cart").addClass("is-active");
    $('body').addClass('slidecart-is-open');
    $('html').addClass('slidecart-is-open');
  });
  
  $(document).on('click','.clscrt',function(){
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
    $('body').removeClass('slidecart-is-open');
    $('html').removeClass('slidecart-is-open');
  });

  $('.top_header_new_cart').click(function(){
    $('body').addClass('cstm_toggle_cls');   
  });

  $("#overlay").click(function(){
    $('body').removeClass('cstm_toggle_cls');  
  });

  $(".cart-header, .cust-fre-shp, .slidecartitmmain").click(function(){
    $('body').removeClass('slidecart-is-open');
    $('html').removeClass('slidecart-is-open');
    $('body').removeClass('cstm_toggle_cls');  
  });

  $('.cart-header, .cust-fre-shp, .slidecartitmmain').click( function(e){
    e.preventDefault();
  });

  $('body').on('click', '.continueshopping', function(e){
    e.preventDefault();
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
    $('body').removeClass('slidecart-is-open');
    $('html').removeClass('slidecart-is-open');
  });

  $('body').on('click', '#overlay', function(){
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
    $('body').removeClass('slidecart-is-open');
    $('html').removeClass('slidecart-is-open');
  });

  $("body").on("click", ".qtyplus", function () {
    var t = +$(this).siblings(".changequantity").val() + 1;
    $(this).siblings(".changequantity").val(t);
  });

  $("body").on("click", ".qtyminus", function () {
    var t = +$(this).siblings(".changequantity").val() - 1;
    t < 1 && (t = 1), $(this).siblings(".changequantity").val(t);
  });


  
  $("body").on("click", ".qtyplus, .qtyminus", function () {
    let url_l = "/cart"    
if (window.location.href.indexOf("/en") > -1) { 
   url_l = "/en/cart" 
  console.log(url_l);
}
    var a = $(this).siblings(".changequantity").val();
      var t =$(this).siblings(".changequantity").attr("data-line-item-index");
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + a + "&line=" + t,
      dataType: "json",
      success: function (t) {     
        console.log(t.item_count);
          $("#cart-count").html(t.item_count),
          $.ajax({
          type: "GET",
          url: url_l,
          dataType: "html",
          success: function (t) {   
            $('#cart-count').removeClass('visually-hidden');
                var minicartdata = $(t).filter('#slidingcartmain').html();
                var progree_msg = $(t).find(".cust-shptxt").html();
                var progree_width = $(t).find(".cust-prg b").attr("style");
               var maincart = $(minicartdata).find('.slidecartitmmain').html();
                var maincartprice = $(minicartdata).find('.slidecart_form').html();
            addRemoveProgress_s(progree_msg,progree_width);
           setTimeout(function(){
                   upsells_slick();
                },200)
                   $('.slidecartitmmain').html(maincart);
                   $('.slidecart_form').html(maincartprice);
            $("#overlay").addClass("is-active"), $(".inline-cart").addClass("is-active"),$('html').addClass('slidecart-is-open');           
          },
        });
      },
    });
  });

  $("body").on("change", ".changequantity", function () {
    let url_c = "/cart"
if (window.location.href.indexOf("/en") > -1) {
   url_c = "/en/cart"
}
    var t = $(this).attr("data-line-item-index");
    console.log(t);
    var a = $(this).val();
    console.log(a),
      $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + a + "&line=" + t,
      dataType: "json",
      success: function (t) {
        if (t.item_count > 0) {
          $("#cart-count").html(t.item_count);
          $('#cart-count').removeClass('visually-hidden');
        } else {
          $("#cart-count").html(t.item_count);
        }
        if(t.item_count == 0){
          $('#cart-count').addClass('visually-hidden');
        }
        $.ajax({
          type: "GET",
          url: url_c,
          dataType: "html",
          success: function (t) {
                      var minicartdata = $(t).filter('#slidingcartmain').html();
               var maincart = $(minicartdata).find('.slidecartitmmain').html();
                var maincartprice = $(minicartdata).find('.slidecart_form').html();
               var progree_msg = $(t).find(".cust-shptxt").html();
                var progree_width = $(t).find(".cust-prg b").attr("style");
                addRemoveProgress_s(progree_msg,progree_width);
           setTimeout(function(){
                   upsells_slick();
                },200)
                   $('.slidecartitmmain').html(maincart);
                   $('.slidecart_form').html(maincartprice);
          },
        });
      },
    });
  });

  $("body").on("click", ".remove-item", function () {
      var quantity_x = $(this).closest(".qty-box-with-remove").find(".cart__qty-input").val();
     
     var line_x = $(this).attr("data-line-item-index");
     console.log(line_x)
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line='+line_x,
      dataType: 'json',
      success: function(response){
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cartdata){
            $('#cart-count').html(cartdata.item_count);
            if(cartdata.item_count > 0){
              $('#cart-count').removeClass('visually-hidden');
            }
            if(cartdata.item_count == 0){
              $('#cart-count').addClass('visually-hidden');
            }
            $.ajax({
              type: "GET",
              url: "/cart",
              dataType: 'html',
              success: function(data) {
                var minicartdata = $(data).filter('#slidingcartmain').html();
               var maincart = $(minicartdata).find('.slidecartitmmain').html();
                var maincartprice = $(minicartdata).find('.slidecart_form').html();
                   var progree_msg = $(data).find(".cust-shptxt").html();
                var progree_width = $(data).find(".cust-prg b").attr("style");
                addRemoveProgress_s(progree_msg,progree_width);
                  $('#slidingcartmain').html(minicartdata);
                 setTimeout(function(){
                   upsells_slick();
                },200)


              }
            });
          }
        });
      }
    });
  })
  

  $(".product-form__cart-submit").click(function(e){
    e.preventDefault();
    let url_c = "/cart"
if (window.location.href.indexOf("/en") > -1) {
   url_c = "/en/cart"
}
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $( this ).closest("form").serialize(),
      dataType: 'json',
      success: function(response){
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cartdata){
            $('#cart-count').html(cartdata.item_count);
            if(cartdata.item_count > 0){
              $('#cart-count').removeClass('visually-hidden');
            }
            if(cartdata.item_count == 0){
              $('#cart-count').addClass('visually-hidden');
            }
            $.ajax({
              type: "GET",
              url: url_c,
              dataType: 'html',
              success: function(data){
               var minicartdata = $(data).filter('#slidingcartmain').html();
                  var progree_msg = $(data).find(".cust-shptxt").html();
                var progree_width = $(data).find(".cust-prg b").attr("style");
                addRemoveProgress_s(progree_msg,progree_width);
                setTimeout(function(){
                   upsells_slick();
                },200)
               
                  $('#slidingcartmain').html(minicartdata);
                $("#overlay").addClass("is-active");
                $("#slidingcartmain").removeClass("slide_empty");
                $(".alm-cart-empty").remove();
                $(".inline-cart").addClass("is-active");
                $('body').addClass('cstm_toggle_cls');
                $('body').addClass('slidecart-is-open');
                $('html').addClass('slidecart-is-open');
                 
              }
            });

          }

        });

      },
      error: function(resp) {
        var getres = JSON.stringify(resp);
        alert(resp.responseJSON.description);
      }
    });

  });




  
  
  

   $(".custom-sticky").click(function(e){
    e.preventDefault();
     $("#main-product .product-form__cart-submit").click()
   })


});
